import { render, staticRenderFns } from "./ApproveClassTaken.vue?vue&type=template&id=2f1a3f54"
import script from "./ApproveClassTaken.vue?vue&type=script&lang=js"
export * from "./ApproveClassTaken.vue?vue&type=script&lang=js"
import style0 from "./ApproveClassTaken.vue?vue&type=style&index=0&id=2f1a3f54&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports